import React, {useEffect, useState} from "react";
import {APIv1} from "../../../api";
import {LogsStatusIcon, StatusIcon} from "../../../utils/statusIcons";
import {useParams} from "react-router-dom";
import {extractDateBySecond} from "../../../utils";
import {useTranslation} from "react-i18next";
import S2PFiscalizationContent from "../../../components/PaymentLogs/S2P/S2PFiscalizationContent";
import {Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import ShareMenu from "../../../components/Buttons/ExportExcel/ShareMenu/ShareMenu";
import "../../../styles/BaseLogsStyle.scss"


const ClickLogS2PDetail = () => {
    const {id} = useParams();
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [logsData, setLogsData] = useState({});
    const [expandedSection, setExpandedSection] = useState(null);
    const [copied, setCopied] = useState(false);

    const toggleSection = (section) => {
        setExpandedSection(prevSection => prevSection === section ? null : section);
    };

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, []); // load once on mount

    useEffect(() => {
        const fetchLogs = async () => {
            if (!userData.token) return;

            try {
                const {data} = await APIv1(`scan2pay/click/logs/detail/${id}`, {
                    headers: {
                        Authorization: `Token ${userData.token}`,
                    }
                });

                const log = data.data;
                const logData = {
                    key: log.id,
                    deviceSerial: log.device_serial_number === 'None' ? '-' : log.device_serial_number,
                    transactionId: log.uuid,
                    orderId: log.order_id,
                    paymentId: log.payment_id,
                    paydocId: log.paydoc_id,
                    signString: log.sign_string,
                    amount: log.amount / 100,
                    isSuccess: log.is_success,
                    status: log.status,
                    state: log.state,
                    paymentType: "Click SHOP-API",
                    fiscalizationRequest: log.fiscalization_request,
                    fiscalizationResponse: log.fiscalization_response,
                    fiscalUrl: log.fiscal_url,
                    prepareRequest: log.prepare_request,
                    prepareResponse: log.prepare_response,
                    completeRequest: log.complete_request,
                    completeResponse: log.complete_response,
                    createdDate: extractDateBySecond(log.created_date)
                };

                setLogsData(logData);
            } catch (error) {
                console.log('Something went wrong:', error);
            }
        };

        fetchLogs();
    }, [userData.token, id]); // Only trigger when token and id are both available

    if (!logsData) {
        return <div>Log not found</div>;
    }

    return (
        <div className="content_container">
            <div className="payment-log__header">
                <div className="payment-log__title">
                    <h1 className="payment-log__main-title">{t("pages.logs.detailColumns.title")} #{logsData.key}</h1>
                </div>
                <div className="payment-log__action-buttons">
                    <ShareMenu url={window.location.href} logsData={logsData} setCopied={setCopied} pdfLogType={"s2pLogs"}/>
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__field">
                    <span className="payment-log__label">{t("common.deviceSerial")}:</span>
                    <span className="payment-log__value">{logsData.deviceSerial}</span>
                </div>

                <div className="payment-log__field">
                        <span className="payment-log__label">
                            <Tooltip title="provided by the provider">
                                <InfoCircleOutlined style={{marginRight: '5px'}}/>
                            </Tooltip>
                            Payment id:
                        </span>
                    <span className="payment-log__value">{logsData.paymentId}</span>
                </div>

                <div className="payment-log__field">
                        <span className="payment-log__label">
                            <Tooltip title="provided by the system FiscalBox">
                                <InfoCircleOutlined style={{marginRight: '5px'}}/>
                            </Tooltip>
                            Transaction id:
                        </span>
                    <span className="payment-log__value">{logsData.transactionId}</span>
                </div>

                <div className="payment-log__field">
                        <span className="payment-log__label">
                            <Tooltip title="provided by the client">
                                <InfoCircleOutlined style={{marginRight: '5px'}}/>
                            </Tooltip>
                            Order id:
                        </span>
                    <span className="payment-log__value">{logsData.orderId}</span>
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__field">
                    <span className="payment-log__label">Amount:</span>
                    <span className="payment-log__value">{logsData.amount}</span>
                </div>

                <div className="payment-log__field">
                    <span className="payment-log__label">Paydoc id:</span>
                    <span className="payment-log__value">{logsData.paydocId}</span>
                </div>

                <div className="payment-log__field">
                    <span className="payment-log__label">Sign String:</span>
                    <span className="payment-log__value">{logsData.signString}</span>
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__field payment-log__field--full">
                        <span className="payment-log__label">
                            Create Request
                        </span>
                    <pre className="payment-log__pre">{logsData.prepareRequest}</pre>
                </div>
                <div className="payment-log__field payment-log__field--full">
                        <span className="payment-log__label">
                            Create Response
                        </span>
                    <pre className="payment-log__pre">{logsData.prepareResponse}</pre>
                </div>
            </div>
            <div className="payment-log__grid">
                <div className="payment-log__field payment-log__field--full">
                        <span className="payment-log__label">
                            Complete Request
                        </span>
                    <pre className="payment-log__pre">{logsData.completeRequest}</pre>
                </div>
                <div className="payment-log__field payment-log__field--full">
                        <span className="payment-log__label">
                            Perform Response
                        </span>
                    <pre className="payment-log__pre">{logsData.completeResponse}</pre>
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__field">
                    <span className="payment-log__label">{t("pages.logs.detailColumns.showcase8")}:</span>
                    <span className="payment-log__value">{logsData.createdDate}</span>
                </div>

                <div className="payment-log__field payment-log__field--row">
                    <span className="payment-log__label">{t("pages.logs.detailColumns.showcase10")}:</span>
                    <div className="payment-log__status">
                        <LogsStatusIcon size={22} status={logsData.status}/>
                        <span className="payment-log__status-text">{logsData.status}</span>
                    </div>
                </div>

                <div className="payment-log__field payment-log__field--row">
                    <span className="payment-log__label">{t("common.status")}:</span>
                    <div className="payment-log__status">
                        <StatusIcon status={logsData.isSuccess}/>
                        <span className="payment-log__status-text">{logsData.isSuccess}</span>
                    </div>
                </div>

                <div className="payment-log__field">
                    <span className="payment-log__label">{t("pages.logs.detailColumns.showcase11")}:</span>
                    {/*<a href={logsData.fiscalUrl} className="payment-log__value" target="_blank"*/}
                    {/*   rel="noreferrer">{logsData.fiscalUrl}</a>*/}
                    {logsData.fiscalUrl ? (
                        <a href={logsData.fiscalUrl} target="_blank" rel="noopener noreferrer"
                           className="detail-view__link">{t("pages.orders.detailColumns.container2.row7")}</a>
                    ) : (
                        <span>{t("common.notAvailable")}</span>
                    )}
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__section">
                    <S2PFiscalizationContent t={t} expandedSection={expandedSection} logsData={logsData}
                                             toggleSection={toggleSection}/>
                </div>
            </div>
        </div>
    );
};


export default ClickLogS2PDetail;
